import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  inject,
  isDevMode,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppService } from '../services/app.service';
import {
  IxFavoriteListComponent,
  IxNgComponentsModule,
  IxNgFavoriteListService,
  IxNgHtmlUtilsService,
  IxNgNavigationService,
  IxNgTopbarService,
} from 'ix-ng-components';
import { ComVizitkaService, NabiralnikComponent } from 'arsktrp-shared-components';
import { IxUiHeightService } from 'ix-ng-core';
import Keycloak from 'keycloak-js';
import { NgClass, NgStyle } from '@angular/common';

const MIN_SCROLL_SENSITIVITY = 15;
const SCROLL_DOWN_TRIGGER = 35;

@Component({
  selector: 'lib-app-topbar',
  templateUrl: './app.topbar.component.html',
  imports: [NgClass, RouterLink, NgStyle, NabiralnikComponent, IxNgComponentsModule],
  styleUrl: './app.topbar.component.scss',
})
export class AppTopBarComponent implements AfterViewInit, OnDestroy {
  appService = inject(AppService);
  ixNgFavoriteListService = inject(IxNgFavoriteListService);
  ixNgHtmlUtilsService = inject(IxNgHtmlUtilsService);
  ixNgTopbarService = inject(IxNgTopbarService);
  ixNgNavigationService = inject(IxNgNavigationService);
  ixUiHeightService = inject(IxUiHeightService);
  keycloak = inject(Keycloak);
  private renderer = inject(Renderer2);
  /**
   * `ComVizitkaService` že v konstruktorju sproži klic `readVizitka`, ki vrne napako če uporabnik ni avtenticiran
   */
  vizitkaService: ComVizitkaService | undefined = this.keycloak.authenticated
    ? inject(ComVizitkaService)
    : undefined;

  @ViewChild('pravica')
  public pravica?: HTMLLIElement;
  @ViewChild('favorites')
  public favorites?: HTMLLIElement;
  @ViewChild('shortcuts')
  public shortcuts?: HTMLLIElement;
  @ViewChild('inputSearch')
  public inputSearch?: ElementRef;
  private lastScrollTop = 0;
  private recalcScroll = false;
  private topbarMenuClickListener?: () => void;

  constructor() {
    IxFavoriteListComponent.showCloseIcon = true;
  }

  ngAfterViewInit(): void {
    this.topbarMenuClickListener = this.renderer.listen('body', 'click', () => {
      if (
        !this.ixNgTopbarService.topbarMenuClick &&
        !this.ixNgTopbarService.topbarMenuButtonClick
      ) {
        this.ixNgTopbarService.topbarMenuActive = false;
      }

      this.ixNgTopbarService.topbarMenuClick = false;
      this.ixNgTopbarService.topbarMenuButtonClick = false;
    });
  }

  ngOnDestroy(): void {
    // remove the listener
    this.topbarMenuClickListener?.();
    this.topbarMenuClickListener = undefined;
  }

  public toggleFavoriteList(event: Event) {
    this.ixNgHtmlUtilsService.onTopbarItemClick(event, this.favorites || null);
    this.ixNgFavoriteListService.appIxFavoriteListOpen =
      !this.ixNgFavoriteListService.appIxFavoriteListOpen;
  }

  public toggleHeader($event: Event) {
    this.ixNgNavigationService.navUp = !this.ixNgNavigationService.navUp;
    $event.preventDefault();
  }

  isPrijavljen(): boolean {
    return !!this.keycloak.authenticated;
  }

  login() {
    this.keycloak.login();
  }

  logout() {
    this.keycloak.logout();
  }

  @HostListener('window:scroll')
  onScrollEvent() {
    // prekinemo, če se recalcScroll že izvaja
    if (this.recalcScroll) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isIE = !!(document as any).documentMode;
    if (!isIE) {
      this.recalcScroll = true;
      setTimeout(() => {
        const docEl = document.documentElement;

        // Equivalent of jQuery(document).scrollTop()
        const st =
          (window.scrollY !== undefined ? window.scrollY : (docEl && docEl.scrollTop) || 0) || 0;

        const last: number = this.lastScrollTop;
        this.lastScrollTop = st;
        this.recalcScroll = false;

        const diff = last - st;
        if (Math.abs(diff) <= MIN_SCROLL_SENSITIVITY) {
          return;
        }

        if (!(st > last && st > SCROLL_DOWN_TRIGGER)) {
          // Scroll Up
          // Equivalent of jQuery(window).height() and jQuery(document).height()
          const windowHeight = window.innerHeight || 600;
          const documentHeight = (docEl && docEl.scrollHeight) || 600;

          if (st + windowHeight < documentHeight) {
            this.ixNgNavigationService.navUp = false;
          } else {
            if (st < MIN_SCROLL_SENSITIVITY && this.ixNgNavigationService.navUp) {
              // we navigated from a page where nav was up, but we are already on top
              this.ixNgNavigationService.navUp = false;
            }
          }
        }
      }, 250);
    }
  }

  @HostListener('window:resize')
  onResizeEvent() {
    this.ixUiHeightService.recalcHeaderHeight();
  }

  onTopbarMenuClick() {
    this.ixNgHtmlUtilsService.onTopbarMenuClick();
    this.ixNgTopbarService.topbarMenuActive = false;
  }

  isDevMode(): boolean {
    return isDevMode();
  }
}
